export enum AccountTypeEnum {
  FOR_MYSELF = 'Individual',
  JOINTLY = 'Joint',
  IN_BEHALF_OF_AN_ENTITY = 'Entity',
  RETIREMENT = 'Retirement',
}

export const entityPlaceholderData = {
  entityData: {
    domicile: 'U.S. citizen',
    entityName: 'EntityName Inc.',
    entityType: 'LLC',
    entityDesc: 'Description of the entity',
    ein: '112223333',
    primCountry: 'USA',
    primAddress1: '123 Main St',
    primAddress2: 'Apt 4B',
    primCity: 'New York',
    primState: 'NY',
    primZip: '10001',
    emailAddress: 'entity@example.com',
    emailAddress2: 'entity2@example.com',
    phone: 1234567890,
    phone2: 9876543210,
    totalAssets: 100000,
    ownersAI: 'Yes',
    KYCstatus: 'Pending',
    AMLstatus: 'Pending',
    AMLdate: '2023-08-18',
    tags: 'tag1,tag2',
    createdIpAddress: '192.168.1.1',
    notes: 'Notes about the entity',
    formationDate: '2023-08-18',
  },
  partyData: {
    domicile: 'U.S. citizen',
    firstName: 'Mary',
    middleInitial: 'D',
    lastName: 'Dee',
    socialSecurityNumber: '112-22-3333',
    dob: '02-28-1975',
    primCountry: 'USA',
    primAddress1: 'PEACHTREE PLACE',
    primAddress2: 'TREE PLACE',
    primCity: 'Atlanta',
    primState: 'GA',
    primZip: '30318',
    emailAddress: 'cee@gmail.com',
    emailAddress2: 'PEACHTREE PLACE',
    phone: '11223364585',
    phone2: '9876543210',
    occupation: 'Developer',
    associatedPerson: 'Yes',
    invest_to: '0',
    empStatus: 'Employed',
    empCountry: 'USA',
    empName: 'Name',
    empAddress1: 'PEACHTREE PLACE',
    empAddress2: 'PEACHTREE PLACE',
    empCity: 'Atlanta',
    empState: 'GA',
    empZip: '30318',
    currentAnnIncome: '200000',
    avgAnnIncome: '200000',
    currentHouseholdIncome: '200000',
    avgHouseholdIncome: '200000',
    householdNetworth: '200000',
    KYCstatus: 'pending',
    AMLstatus: 'pending',
    AMLdate: '02-15-2016',
    tags: 'tags',
    field1: 'some text',
    field2: 'some text',
    field3: 'some text',
    createdIpAddress: '10.0.0.111',
    notes: 'Notes Added',
  },
  accountData: {
    email: 'test@test.com',
    accountRegistration: 'Ape',
    type: 'Individual',
    entityType: 'Revocable Trust',
    domesticYN: 'domestic account',
    streetAddress1: 'First street',
    streetAddress2: 'Third avenue',
    city: 'ATLANTA',
    state: 'GA',
    zip: '32526',
    country: 'USA',
    phone: '41545218563',
    taxID: '875451545875856',
    KYCstatus: 'pending',
    AMLstatus: 'pending',
    suitabilityScore: '5',
    suitabilityDate: '02-18-2016',
    suitabilityApprover: 'smith',
    AccreditedStatus: 'pending',
    AIlow: 'income',
    AIdate: '02-18-2016',
    '506cLimit': '50000',
    accountTotalLimit: '200000',
    singleInvestmentLimit: '100',
    associatedAC: 'yes',
    syndicate: 'no',
    tags: 'terms',
    notes: 'Personal Account',
    approvalStatus: 'pending',
    approvalPrincipal: 'Charles',
    approvalLastReview: '02-15-2016',
    field1: 'some text',
    field2: 'some text',
    field3: 'some text',
  },
  linkData: {
    firstEntryType: 'Account',
    relatedEntryType: 'IndivACParty',
    primary_value: '1',
    linkType: 'member',
    notes: 'Notes',
  },
}
